import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import LOOutcomeModalCst from "@components/LOOutcomeModalCst";
import ActivityWizard from "../Activity/ActivityWizard";
import { ActivityWizardData } from "./types";
import { useSubmitActivityV2 } from "./hooks/useSubmitActivityV2";
import { useSaveDraft } from "../hooks/useSaveDraft";

export const INITIAL_DATA: ActivityWizardData = {
  type: null,
  title: "",
  detail_description: "",
  duration: "",
  digited_code: "",
  xapi_package_id: null,
  scorm_package_id: null,
  external_file_url: "",
  is_link_relative: false,
  is_editorial: false,
  completion_required: false,
  flag_authentication: false,
  client_id: "",
  client_secret: "",
  sso_auth: false,
  download_flag: false,
  youtube_video: "",
  external_id: "",
  lti_account_id: null,
  survey_id: null,
  agenda: [],
  min_partecipant: "",
  max_partecipant: "",
  min_completition_perc: "",
  self_enrollment: false,
  cover_id: null,
  video_id: null,
  is_standalone: false,
  schedule_publication: false,
  publish_date: null,
  obsolescent_date: null,
  fruition_flag: false,
  time_slots: [],
  didactical_material: [],
  useful_links: [],
  stakeholders: [],
  certificate_ids: [],
  signature_certificate_ids: [],
  badge_id: null,
  complexity: null,
  score: "",
  credits: "",
  lo_tag: [],
  available_languages: [],
  selected_initiatives: [],
  editorial_per_initiative: {},
  highlight_explore: false,
};

const AddActivityV2: React.FC = () => {
  const { t: tOutcome } = useTranslation("lo-outcome-modal");
  const navigate = useNavigate();
  const { id: corporateId = "" } = useParams();

  const catalogUrl = `/v2/corporate/${corporateId}/detail/catalog`;

  const { saveDraft, isSavingDraft } = useSaveDraft({
    corporateId,
    type: "activity",
  });
  const { submit: submitActivity, isSubmitting } = useSubmitActivityV2({
    corporateId,
  });

  const [successOpen, setSuccessOpen] = useState(false);

  const handleComplete = async (data: ActivityWizardData) => {
    try {
      await submitActivity(data);
      setSuccessOpen(true);
    } catch (error) {
      console.error("[wizard-activity] publish failed", error);
      throw error;
    }
  };

  const handleSaveDraft = async (data: ActivityWizardData) => {
    try {
      await saveDraft(data);
      navigate(`${catalogUrl}?tab=all`);
    } catch (error) {
      console.error("[wizard-activity] saveDraft failed", error);
      throw error;
    }
  };

  return (
    <>
      <ActivityWizard
        initialData={INITIAL_DATA}
        onComplete={handleComplete}
        onSaveDraft={handleSaveDraft}
        isSavingDraft={isSavingDraft}
        isSubmitting={isSubmitting}
        mode="add"
      />
      <LOOutcomeModalCst
        open={successOpen}
        entityType="activity"
        mode="add"
        associationOptions={[
          {
            key: "course",
            title: tOutcome("options.course.title"),
            description: tOutcome("options.course.description"),
          },
          {
            key: "path",
            title: tOutcome("options.path.title"),
            description: tOutcome("options.path.description"),
          },
        ]}
        onAssociate={(key) => {
          navigate(`${catalogUrl}?tab=${key === "path" ? "paths" : "courses"}`);
        }}
        onDismiss={() => navigate(catalogUrl)}
      />
    </>
  );
};

export default AddActivityV2;
